export default "__VITE_ASSET___rhshnPL__"